/**
 * Two Col Header and Text — Image Carousel
 *
 * When a row is in "carousel" media mode, the PHP template renders Glide.js
 * markup with `[data-tch-carousel]`. This script mounts the slider with:
 *   - perView: 1 (full-image slides)
 *   - autoplay every 5s (paused on hover/focus)
 *   - seamless infinite loop (type: "carousel")
 *   - arrows hidden / Glide skipped entirely when only 1 image is present
 */

document.addEventListener("DOMContentLoaded", () => {
  const carousels = document.querySelectorAll("[data-tch-carousel]");
  if (!carousels.length || typeof Glide === "undefined") return;

  carousels.forEach((el) => {
    const slideCount = parseInt(el.dataset.slideCount || "0", 10);

    // Single-slide carousel: nothing to scroll through. Skip mounting Glide
    // entirely so we don't get phantom autoplay or duplicated DOM nodes.
    if (slideCount <= 1) return;

    new Glide(el, {
      type: "carousel", // seamless infinite loop
      perView: 1,
      autoplay: 5000,
      hoverpause: true,
      animationDuration: 600,
      animationTimingFunc: "cubic-bezier(0.22, 0.61, 0.36, 1)",
    }).mount();
  });
});
